import { INFOBOX_VARIANT } from '@motorway/mw-highway-code/enums';

import { BULK_BIDDING_ERROR_TYPES } from '../../error.helpers';

export const RESULT_TYPE = { FAILED: 'failed', SUCCESSFUL: 'successful' } as const;
export type ResultType = (typeof RESULT_TYPE)[keyof typeof RESULT_TYPE];

export const INFOBOX_VARIANT_MAP = {
	[RESULT_TYPE.FAILED]: INFOBOX_VARIANT.ERROR,
	[RESULT_TYPE.SUCCESSFUL]: INFOBOX_VARIANT.SUCCESS,
};

export const FAILED_BIDS_REASON_ORDER = [
	BULK_BIDDING_ERROR_TYPES.BID_FLOOR,
	BULK_BIDDING_ERROR_TYPES.BID_ALREADY_PLACED,
	BULK_BIDDING_ERROR_TYPES.INVALID_FORMAT,
	BULK_BIDDING_ERROR_TYPES.DEALER_OWNS_VEHICLE,
	BULK_BIDDING_ERROR_TYPES.GENERAL_ERROR,
] as const;
